module.exports = __webpack_public_path__ + "img/filter-selected.a77907b9.svg";